import React from "react";

const index = () => {
  return <div>case studies post</div>;
};

export default index;
